import React from 'react';
import SideMenu  from './SideMenu';
import BottomNav from './BottomNav';
import TopBar    from './TopBar';
import Notification from '../ui/Notification';
import { useApp }   from '../../context/AppContext';
import { useSocket } from '../../hooks/useSocket';
import useFCM        from '../../hooks/useFCM';

import DashboardPage     from '../../pages/DashboardPage';
import RequestsPage      from '../../pages/RequestsPage';
import NewRequestPage    from '../../pages/NewRequestPage';
import ProfilePage       from '../../pages/ProfilePage';
import PropertiesPage    from '../../pages/PropertiesPage';
import TicketsPage       from '../../pages/TicketsPage';
import WalletPage        from '../../pages/WalletPage';
import NotificationsPage from '../../pages/NotificationsPage';

const PAGE_TITLES = {
  dashboard:     'HostAssist',
  requests:      'My Requests',
  new:           'New Request',
  profile:       'My Profile',
  properties:    'My Properties',
  tickets:       'Support Tickets',
  wallet:        'My Wallet',
  notifications: 'Notifications',
};

const AppShell = () => {
  const { activeTab, notification } = useApp();
  useSocket();
  useFCM();

  const renderPage = () => {
    switch (activeTab) {
      case 'dashboard':  return <DashboardPage />;
      case 'requests':   return <RequestsPage />;
      case 'new':        return <NewRequestPage />;
      case 'profile':    return <ProfilePage />;
      case 'properties': return <PropertiesPage />;
      case 'tickets':       return <TicketsPage />;
      case 'wallet':        return <WalletPage />;
      case 'notifications': return <NotificationsPage />;
      default:              return <DashboardPage />;
    }
  };

  return (
    <div className="app-shell flex flex-col">
      {/* Ambient background glow — very subtle on light bg */}
      <div
        className="absolute top-0 right-0 w-60 h-60 rounded-full pointer-events-none opacity-[0.04]"
        style={{ background: 'radial-gradient(circle, #6366f1 0%, transparent 70%)', transform: 'translate(30%, -30%)' }}
      />

      <Notification notification={notification} />
      <SideMenu />
      <TopBar title={PAGE_TITLES[activeTab] || 'HostAssist'} />

      <main className="flex-1 overflow-hidden relative">
        {renderPage()}
      </main>

      <BottomNav />
    </div>
  );
};

export default AppShell;
